export default function CircleCheckIcon({ className }: { className?: string }) {
  return (
    <svg
      width='23'
      height='23'
      viewBox='0 0 23 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <circle
        cx='11.0158'
        cy='11.0158'
        r='11.0158'
        fill='currentColor'
      />
      <path
        d='M16.3685 6.92578L9.44426 13.85L6.29688 10.7026'
        stroke='white'
        strokeWidth='1.37698'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
